import { useEffect, useState } from 'react';
import dbData from '../db/db.json';

export interface GlobalDataShape {
    companyDetails: {
        name: string;
        email: string;
        phone: string;
        address: string;
        city: string;
        accountNumber: string;
        iban: string;
        swiftCode: string;
        businessNumber: string;
        taxNumber: string;
        orderNumber: string;
        digitalSignature: string;
    };
    emailContent: Record<string, unknown>;
}

export const GLOBAL_DATA_STORAGE_KEY = 'kos-cat-recycler-global-data';
const GLOBAL_DATA_UPDATED_EVENT = 'global-data-updated';

export const loadGlobalData = (): GlobalDataShape => {
    try {
        const stored = localStorage.getItem(GLOBAL_DATA_STORAGE_KEY);
        if (!stored) return dbData as GlobalDataShape;

        const parsed = JSON.parse(stored) as Partial<GlobalDataShape>;
        return {
            companyDetails: {
                ...(dbData as GlobalDataShape).companyDetails,
                ...(parsed.companyDetails || {})
            },
            emailContent: {
                ...(dbData as GlobalDataShape).emailContent,
                ...(parsed.emailContent || {})
            }
        };
    } catch {
        return dbData as GlobalDataShape;
    }
};

export const saveGlobalData = (next: GlobalDataShape) => {
    localStorage.setItem(GLOBAL_DATA_STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(new Event(GLOBAL_DATA_UPDATED_EVENT));
};

export const useGlobalData = () => {
    const [data, setData] = useState<GlobalDataShape>(() => loadGlobalData());

    useEffect(() => {
        const refresh = () => setData(loadGlobalData());
        window.addEventListener('storage', refresh);
        window.addEventListener(GLOBAL_DATA_UPDATED_EVENT, refresh);
        return () => {
            window.removeEventListener('storage', refresh);
            window.removeEventListener(GLOBAL_DATA_UPDATED_EVENT, refresh);
        };
    }, []);

    return data;
};